module.exports = __webpack_public_path__ + "img/training-martial-arts.d8175c34.svg";